import { useQuery } from '@tanstack/react-query';

import { getMediaAsset } from '~/services/MediaService';

import { mediaAssetQueryKeys } from './mediaQueryKeys';

/** Fetches one media asset. Idle until an id is known, so a blank route does not call out. */
export function useGetMediaAsset(assetId: string) {
  return useQuery({
    queryKey: mediaAssetQueryKeys.detail(assetId),
    queryFn: ({ signal }) => getMediaAsset(assetId, { signal }),
    enabled: Boolean(assetId),
  });
}
